<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-email-fast" icon-small title="تیکت ها و پیام ها" color="accent">
			<template v-slot:topActions>
				<v-btn color="primary " dark class="mx-1" @click="add">
					<v-icon dark>
						mdi-plus-circle-outline
					</v-icon>
					تیکت جدید
				</v-btn>
				<v-btn color="primary " fab outlined small dark class="mx-1" @click="loadData">
					<v-icon dark>
						mdi-refresh
					</v-icon>
				</v-btn>
			</template>
			<div class="pa-5 pt-0">
				<v-row>
					<v-col cols="12" md="6">
						<v-text-field @change="loadData" v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
					</v-col>
					<v-col cols="12">
						<v-data-table :height="dataTableFixedHeight - 100" fixed-header :options.sync="options" :server-items-length="countAll" dense :headers="headers" :loading="loading" :items="items" :footer-props="{ 'items-per-page-options': [5, 25, 50, 100] }" :items-per-page="itemsPerPage" :search="search" class="elevation-1">
							<template v-slot:item.code="{ item }">
								<div style="cursor: pointer;" @click="edit(item)" class="info--text">{{ item.code }}</div>
							</template>
							<template v-slot:item.createdByFullName="{ item }">
								<div><small>{{ item.createdByFullName }}</small></div>
								<div class="grey--text"><small>{{ item.role_Str }}</small></div>
							</template>
							<template v-slot:item.createdAt="{ item }">
								<small>&lrm;{{ item.createdAt }}</small>
							</template>
							<template v-slot:item.status_Str="{ item }">
								<v-chip small :color="getStatusColor(item.status)">{{ item.status_Str }}</v-chip>
							</template>
							<template v-slot:item.title="{ item }">
								<small>{{ item.title }}</small>
							</template>
							<template v-slot:item.asMessage="{ item }">
								<div class=""><small>نوع: {{ item.asMessage ? 'پیام' : 'تیکت' }}</small></div>
								<div class="grey--text" v-if="item.userLoanCode"><small>شماره وام مرتبط: {{ item.userLoanCode }}</small></div>
								<div class="grey--text" v-if="item.userLoanRequestCode"><small>شماره درخواست وام مرتبط: {{ item.userLoanRequestCode }}</small></div>
							</template>
							<template v-slot:item.operations="{ item }">
								<td class="text-center">
									<v-btn class="mx-1" dark small color="secondary" @click="edit(item)">
										مشاهده
									</v-btn>
								</td>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</div>
			<v-dialog v-model="dialog" scrollable persistent max-width="1100px">
				<v-card>
					<v-card-title>
						<span class="headline">ثبت تیکت</span>
						<v-spacer />
						<v-btn @click="dialog = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-container fluid>
							<modify-ticket ref="modifyTicket" :userType="userType" v-if="dialog" :ticketId="selectedTicketId" @callbck="callbck" />
						</v-container>
					</v-card-text>
				</v-card>
			</v-dialog>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import { get } from 'vuex-pathify'
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'AgentTicketView',
		props: {
			userType: {
				type: String,
			}
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'modify-ticket': () => import('./ModifyTicket.vue'),
		},
		data() {
			return {
				countAll: 0,
				options: {},
				errorMessages: '',
				localData: {},
				selectedTicketId: {},
				dialog: false,
				search: '',
				dateRange: { start: new Date(new Date().setMonth(new Date().getMonth() - 1)).toJSON(), end: '' },
				headers: [
					{
						text: 'شماره تیکت',
						align: 'start',
						sortable: true,
						value: 'code',
						width: 80
					}, {
						text: 'ایجاد کننده',
						align: 'start',
						sortable: true,
						value: 'createdByFullName',
						width: 150
					}, {
						text: 'زمان ایجاد',
						align: 'start',
						sortable: true,
						value: 'createdAt',
						width: 120
					},
					{
						text: 'عنوان',
						align: 'start',
						sortable: true,
						value: 'title',
					},
					{
						text: 'وضعیت',
						align: 'center',
						sortable: true,
						value: 'status_Str',
					},
					{
						text: 'تعداد پاسخ',
						align: 'center',
						sortable: true,
						value: 'responseCount',
					},
					{
						text: 'اطلاعات تکمیلی',
						align: 'center',
						sortable: true,
						value: 'asMessage',
						width: 150
					},
					{
						text: 'عملیات ها',
						align: 'center',
						sortable: false,
						value: 'operations',
						width: 150,
					},
				],
				itemsPerPage: 25,
				items: [],
				loading: false
			}
		},
		watch: {
			options: {
				handler() {
					this.loadData()
				},
				deep: true,
			}
		},
		mounted() {
			this.loadData()
		},
		computed: {

		},
		methods: {
			loadData(e) {
				if (this.loading) {
					return
				}
				if (e && e === this.previousSearch)
					return
				this.previousSearch = this.search
				this.loading = true
				const data = {
					sortBy: this.options.sortBy,
					sortDesc: this.options.sortDesc,
					page: (this.options.page || 1),
					itemsPerPage: (this.options.itemsPerPage || this.itemsPerPage),
					search: this.search
				}

				api.post(`${this.userType}/ticket/List/`, data)
					.then(
						response => {
							this.items = response.tickets
							this.countAll = response.countAll
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			add() {
				this.selectedTicketId = ''
				this.dialog = true
			},
			edit(item) {
				this.selectedTicketId = item.id
				this.dialog = true
			},
			callbck(result) {
				if (result === 'close') {
					this.dialog = false
					return
				}
				if (result) {
					this.loadData()
				}
			},
			async remove(item) {
				if (!item) {
					return
				}

				if (
					await this.$refs.confirm.open(
						'توجه',
						'آیا از حذف این آیتم مطمئن هستید؟',
					)
				) {
					api
						.post('agent/userLoanRequest/delete/' + item.id)
						.then(response => {
							toast.success('اطلاعات با موفقیت حذف شد.')
							this.loadData()
						})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			getStatusColor(status) {
				let d = {
					0: '#ffe4bc',
					1: '#ffe4bc',
					2: '#c7ffbc',
					3: '#ddd'
				}
				return d[status]
			}
		},
	}
</script>
<style></style>
